<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :persistenceKey="'session-management-list'"
    :loadDataGrid="loaded"
    :backButtonEnable="true"
    :backButtonRoute="'/settings/user'"
    ref="session-management-list"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";

import TransactionListTemplate from "@/templates/transaction-list";
import { SessionManagementService } from "@/_services/api/settings/user/session-management.service";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      loaded: false,
      gcPopupCustomerStatementConfig: {},
    };
  },
  computed: {
    defaultDateFilterValue() {
      let d = new Date();
      d.setMonth(d.getMonth() - 3);
      return d;
    },
    setScreenConfig() {
      var config = {
        title: "Session Management",

        exportFileName: "Session Management List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "UserSessionList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              select: ["SessionId"].concat(
                this.getSelectFields(this.getColumns)
              ),
              postProcessCallback: this.userSessionListPostProcessCallback,
            },
            options: {
              selectionMode: "multiple",
            },

            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Call Logs",
                message: "Get Started, Add a Call Log",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: false,
            export: false,
            openFilter: true,
            expand: false,
            filterOnEnter: true,
            customButtons: [
              {
                icon: "trash",
                label: "",
                clickAction: this.removeSessions,
                buttonLocation: "right",
              },
            ],
          },
          columns: this.getColumns,
        },
      };

      return config;
    },
    getColumns() {
      return [
        {
          screenField: "CreatedBy",
          dataField: "Username",
          filterDataField: "Username",
          label: "Username",
          filterLabel: "Username",
          filterIndex: 1,
        },
        {
          screenField: "StartTime",
          type: "DateTime",
          format: "dd MMM yyyy HH:mm:ss",
          dataField: "CreatedAt",
          label: "Session Created",
        },
        {
          screenField: "StartTime",
          type: "Date",
          dataField: "CreatedAt",
          filterDataField: "CreatedAt",
          filterLabel: "Session Created",
          filterIndex: 3,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "StartTime",
          type: "DateTime",
          format: "dd MMM yyyy HH:mm:ss",
          dataField: "LastActivityAt",
          filterDataField: "LastActivityAt",
          label: "Last Activity",
          width: ColumnWidth.Date.width,
        },
        {
          screenField: "CreatedBy",
          dataField: "DeviceFingerprint",
          filterDataField: "DeviceFingerprint",
          label: "Device ID",
          width: 300,
        },
        {
          screenField: "CreatedBy",
          dataField: "LicenseType",
          filterDataField: "LicenseType",
          label: "License Type",
        },
        {
          screenField: "OrderStatus",
          dataField: "FriendlyStatus",
          visible: true,
        },
        {
          screenField: "GridRecordEllipsisMenu",
          select: false,
          allowSearch: false,
          cssClass: "padding-7",
          ellipsisMenu: {
            itemAction: (data) => {
              var items = [
                {
                  menuText: "Remove",
                  data: data,
                  clickAction: this.removeSession,
                  disabled: false,
                },
              ];

              return items;
            },
            keyExpr: "menuText",
            displayExpr: "menuText",
          },
          dropDownOptions: {
            width: 100,
          },
        },
      ];
    },
  },
  methods: {
    reloadDataSource() {
      this.$nextTick(() => {
        this.$refs["session-management-list"].$refs[
          "transactionListGrid"
        ].gridRepaint();
      });
    },
    async removeSessions() {
      let selectedRows =
        this.$refs["session-management-list"].$refs[
          "transactionListGrid"
        ].selectedRowData();

      if (selectedRows.length > 0) {
        let confirmRemove = await this.$confirm(
          "Are you sure you want to remove the selected sessions?",
          "Remove Sessions"
        );

        if (!confirmRemove) return;

        var selectedSessionIds = selectedRows.map((row) => row.SessionId);
        SessionManagementService.removeSessions(selectedSessionIds)
          .then((res) => {
            this.$notify(
              `The selected session(s) have been removed successfully.`,
              "success"
            );
            if (res) {
              this.reloadDataSource();
            }
          })
          .catch((err) => {
            if (err) this.displayServerError(err, "Remove Failed");
          });
      } else {
        this.$alert(
          "At least one Session line should be selected.",
          "Remove Failed"
        );
      }
    },
    userSessionListPostProcessCallback(data) {
      data.forEach((element) => {
        if (element.LastActivityAt)
          element.LastActivityAt = element.LastActivityAt.dateWithOffset();

        if (element.CreatedAt)
          element.CreatedAt = element.CreatedAt.dateWithOffset();
      });
      return data;
    },
    async removeSession(e) {
      let confirmRemove = await this.$confirm(
        "Are you sure you want to remove this session?",
        "Remove Session"
      );

      if (confirmRemove) {
        this.showLoading(true);
        await SessionManagementService.removeSession(e.SessionId)
          .then((res) => {
            this.$notify(
              `The selected session(s) have been removed successfully.`,
              "success"
            );
            if (res) {
              this.reloadDataSource();
            }
            this.showLoading(false);
          })
          .catch((err) => {
            if (err) this.displayServerError(err, "Remove Failed");
            this.showLoading(false);
          });
      }
    },
    // eslint-disable-next-line no-unused-vars
    navigateToDestination(e) {
      this.$router.push({
        path: `settings`,
      });
    },
  },

  async created() {
    this.loaded = true;
  },
};
</script>

<style lang="scss"></style>
